export function unwrapBody<TData>(response: { data: TData }): TData {
  return response.data;
}
